import $ from 'jquery';
import {ENDERECO_API} from '../../config/constant';
import {decode as base64_decode, encode as base64_encode} from 'base-64';

/**
 * Service do questionário de visitante anônimo (público, sem token).
 *
 * Usa o roteador público `espiaoCtrlPbl_.class.php`, mesmo molde de
 * `services/changelog`. A diferença é `xhrFields.withCredentials`, necessário
 * para que o cookie HttpOnly `visitor_token` emitido pelo servidor viaje
 * quando o front está em origem diferente da API (cenário de desenvolvimento).
 */

// O roteador público espera [emp, uid, payload]; aqui não há sessão.
const EMP = '0';
const UID = '0';

const montaDd = (payload) =>
  base64_encode(
    JSON.stringify([
      base64_encode(EMP),
      base64_encode(UID),
      base64_encode(JSON.stringify(payload ?? {})),
    ])
  );

const ajaxVisitante = ({type, ll, payload}) =>
  new Promise(function (resolve, reject) {
    try {
      $.ajax({
        url: `${ENDERECO_API}src/api/controller/espiaoCtrlPbl_.class.php`,
        type,
        dataType: 'json',
        xhrFields: {withCredentials: true},
        data: {
          pp: base64_encode('visitante'),
          ll: base64_encode(ll),
          dd: montaDd(payload),
        },
        success: function (data) {
          try {
            resolve([200, JSON.parse(base64_decode(data))]);
          } catch (e) {
            // Resposta ilegível não é motivo para quebrar o cadastro.
            reject([400, {success: false, error: 'Resposta inválida'}]);
          }
        },
        error: function (xhr) {
          reject([xhr?.status || 400, {success: false, error: 'Falha na requisição'}]);
        },
      });
    } catch (err) {
      reject([500, {success: false, error: 'Server Error: ' + err.message}]);
    }
  });

const RestVisitantePost = (config) => {
  const Arr_ = JSON.parse(config.data);
  const caminho = Arr_.dest.trim();

  switch (caminho) {
    // Envio da primeira etapa. A resposta ({modulo, ufs_nao_suportadas})
    // decide o caminho do cadastro.
    case 'etapaInicial':
      return ajaxVisitante({
        type: 'POST',
        ll: 'etapaInicial',
        payload: {
          opcoes: Arr_.opcoes ?? [],
          ufs: Arr_.ufs ?? [],
        },
      });

    // aceitou_teste / recusou_teste. O servidor preenche o resto.
    case 'registrarEvento':
      return ajaxVisitante({
        type: 'POST',
        ll: 'registrarEvento',
        payload: {
          pergunta_id: Arr_.pergunta_id,
          tipo_evento: Arr_.tipo_evento,
        },
      });

    default:
      return new Promise((resolve) => resolve([404, {success: false, error: 'Rota não encontrada'}]));
  }
};

const RestVisitanteGet = (config) => {
  const caminho = (config.dest || '').trim();

  switch (caminho) {
    case 'getEstadosNfce':
      return ajaxVisitante({type: 'GET', ll: 'getEstadosNfce', payload: {}});

    default:
      return new Promise((resolve) => resolve([404, {success: false, error: 'Rota não encontrada'}]));
  }
};

export {RestVisitantePost, RestVisitanteGet};
